var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M26.3 14.6h-10M26.3 25.1h-10M16.2 19.9h10.1M27.4 35H15.1c-2.6 0-4.7-2.1-4.7-4.7v-17c0-2.6 2.1-4.7 4.7-4.7h12.3c2.6 0 4.7 2.1 4.7 4.7v17.1c0 2.5-2.1 4.6-4.7 4.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsimple);
export default __webpack_public_path__ + "static/media/docsimple.a5af804a35d069c3ac72bcf3555d2d2b.svg";
export { ForwardRef as ReactComponent };